import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Col, Container, Row } from "reactstrap";
import { AxiosResponse } from "axios";

import { ApiCore } from "../../helpers/api_helper";
import { Endpoints } from "../../utils/Endpoints";
import { Loading } from "../../components/common/Loading";
import Student from "./Student";
import Post from "./Post";

const request = new ApiCore();

const Dashboard = () => {
  const [loadingStudents, setLoadingStudents] = useState<boolean>(true);
  const [students, setStudents] = useState<any[]>([]);

  const [loadingPosts, setLoadingPosts] = useState<boolean>(true);
  const [posts, setPosts] = useState<any[]>([]);

  useEffect(() => {
    request
      .get(Endpoints.students, {})
      .then((response: AxiosResponse) => {
        setStudents(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoadingStudents(false);
      });

    request
      .get(Endpoints.posts, {})
      .then((response: AxiosResponse) => {
        setPosts(Array.isArray(response.data) ? response.data : []);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoadingPosts(false);
      });
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Home</title>
        </MetaTags>

        <Container fluid>
          <Row>
            <Col lg={5}>
              {loadingStudents && <Loading label="Loading students..." />}
              {!loadingStudents && <Student data={students} />}
            </Col>
            <Col lg={7}>
              {loadingPosts && <Loading label="Loading posts..." />}
              {!loadingPosts && <Post data={posts} />}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
